export enum UnderscoreClasses {
  NoTransform,
  CamelCaseTransform,
}
